/* eslint-disable prefer-destructuring */
/* eslint-disable no-underscore-dangle */
import { Eye } from 'iconsax-react';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useLocation, useNavigate } from 'react-router-dom';
import Button from '../../assets/styles/Button';
import Center from '../../assets/styles/Center';
import DefaultContainer from '../../assets/styles/DefaultContainer';
import Text from '../../assets/styles/Text';
import Loader from '../../components/Loader';
import ModelService from '../../services/ModelService';
import { useStore } from '../../stores';
import Infos from './components/Infos';
import Plans from './components/Plans';
import Uploads from './components/Uploads';
import * as styles from './styles';

export default function ModelDashboard() {
  const [loading, setLoading] = useState(true);
  const [model, setModel] = useState([]);

  const user = useStore((state) => state.user);

  const navigate = useNavigate();
  const location = useLocation();

  const hash = location.hash.slice(1);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get('payment') === 'success') {
      toast.success('Pagamento confirmado! Seu plano foi ativado.');
      navigate('/modeldashboard', { replace: true });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    async function loadById() {
      try {
        setLoading(true);
        const getModel = await ModelService.findHeaderModel(user.id);

        setModel(getModel);
      } catch (error) {
      } finally {
        setLoading(false);
      }
    }

    loadById();
  }, [user, navigate]);

  function handleShow(hashUrl) {
    navigate(hashUrl);
  }

  if (loading) return <Loader isLoading={loading} />;

  return (
    <DefaultContainer>
      <Center className="center">
        <styles.Top>
          <Text.H2>
            Bem vindo - <b>{model?.fantasyName || 'Adicione seu nome'}</b>
          </Text.H2>

          <div>
            <Eye size={24} />
            <Text.P>
              <Text.Span>{model?._count?.visits || 0}</Text.Span>
              visita(s) no último mês
            </Text.P>
          </div>
        </styles.Top>

        <styles.Container>
          <Button
            type="button"
            $radius={32}
            $padding={8}
            $active={hash === ''}
            onClick={() => handleShow('')}
          >
            <Text.H4 $bold>Informações</Text.H4>
          </Button>

          <Button
            type="button"
            $radius={32}
            $padding={8}
            $active={hash === 'uploads'}
            onClick={() => handleShow('#uploads')}
          >
            <Text.H4 $bold>Uploads</Text.H4>
          </Button>

          <Button
            type="button"
            $radius={32}
            $padding={8}
            $active={hash === 'plans'}
            onClick={() => handleShow('#plans')}
          >
            <Text.H4 $bold>Planos</Text.H4>
          </Button>
        </styles.Container>

        <Infos show={hash === ''} />
        <Uploads show={hash === 'uploads'} />
        <Plans show={hash === 'plans'} />
      </Center>
    </DefaultContainer>
  );
}
